import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.userInfo || _ctx.initialsObject)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "circle btn-bg-light",
        style: _normalizeStyle(`background-color:${
      _ctx.userInfo ? _ctx.userInfo.avatarColor : _ctx.initialsObject.avatarColor
    }; height:${_ctx.avatarSize}rem; width:${_ctx.avatarSize}rem;`),
        title: _ctx.userInfo ? _ctx.userInfo.fullName : _ctx.initialsObject.fullName
      }, [
        _createElementVNode("span", {
          class: "initials color-white",
          style: _normalizeStyle(`font-size:${_ctx.avatarSize / 2}rem; top:${_ctx.avatarSize /3.5}rem`)
        }, _toDisplayString(_ctx.userInfo ? _ctx.userInfo.initials : _ctx.initialsObject.initialsName), 5)
      ], 12, _hoisted_1))
    : _createCommentVNode("", true)
}